import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { InsightContentSettingType } from 'components/insightContent/types'
import { PostTypeGroup } from 'enums'
import RunSearchEffect from '../share/RunSearchEffect'
import InsightTable from '../share/InsightTable'

const Replies = ({ detailSetting }: { detailSetting: InsightContentSettingType }) => (
  <UnexpectedErrorBoundary>
    <RunSearchEffect postType={PostTypeGroup.REPLIES} detailSetting={detailSetting}>
      <InsightTable postType={PostTypeGroup.REPLIES} />
    </RunSearchEffect>
  </UnexpectedErrorBoundary>
)

export default Replies
